import $ from 'jquery';
import GET_ARTICLES from "../class/getArticles";
import GET_ARTICLE_SHARED from "../class/getArticleShared";
import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const REMOTE_ARTICLE_API_ORIGIN = 'https://iwata.websapo.jp';
const domReady = TPL => {
  new BLOCKS;
};

class BLOCKS {
  constructor() {
    this.mainvisual();
    this.fixedBanner();
    this.case();
    this.voice();
    this.seminar();
    this.news();
    this.bannerClose();
  }
  
  mainvisual () {
    let Mv = document.querySelector('.mainvisual');
    w.addEventListener('load', function() {
      Mv.classList.add('loaded');
    });

    //メインスライダー
    const mvSlide = new Swiper('.mainvisual__slide[data-plugin="mainSlider"]',{
      loop: true,
      // effect: 'fade',
      speed: 1200,
      allowTouchMove: false,
      slidesPerView: 'auto',

      autoplay:{
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: false
      },
      pagination: {
        el: ".mainvisual__pagination",
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
					return (
					`<div class="${ className }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><circle cx="5" cy="5" r="4" /></svg>
          </div>`
					)
				}
      },
    });
  }

  fixedBanner() {
    const target = d.querySelector('[data-template="banner"]');
    if (!target) return;

    const seminarBanner = new GET_ARTICLES('[data-template="banner"]');
    seminarBanner.makeItem = (item) => {
      const [year, month, date, weekday, startTime] = item.desc.split('/');
      
      return `
        <p class="year">${year}</p>
        <p class="date">${month}.${date}</p>
        <p class="extra">
          <span class="weekday">${weekday}</span>
          <span class="time">${startTime}-</span>
        </p>
      `;
    };
    seminarBanner.render();
  }

  case () {
    const getArticle = new GET_ARTICLE_SHARED('.block-case__slide-wrapper', {
      apiOrigin: REMOTE_ARTICLE_API_ORIGIN
    });
    getArticle.makeItem = (item,content) => {
      return `
      <div class="swiper-slide block-case__item">
        <a href="${item.href}" class="block-case__link">
          <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy">
        </a>
      </div>`};
    // getArticle.makeItem = (item) => console.log(item);
    getArticle.render();

    const caseSlider = new Swiper('.block-case__slide', {
      grabCursor: true,
      speed: 400,
      slidesPerView: 1.2,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        500: {
          slidesPerView: 'auto',
          spaceBetween: 30,
        }
      },
    });
  }

  voice () {
    const getArticle = new GET_ARTICLE_SHARED('.block-voice__slide-wrapper', {
      apiOrigin: REMOTE_ARTICLE_API_ORIGIN
    });
    getArticle.makeItem = (item, content) => {
      const [company, position, name] = item.desc.split('|');
      let displayThumb = item.thumb;
      if (item.body) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = item.body;
        const customThumb = tempDiv.querySelector('img[data-thumb="top-slide"]');
        if (customThumb) {
          displayThumb = customThumb.getAttribute('src');
        }
      }
      if (!displayThumb || displayThumb === "") {
        displayThumb = '/assets/img/common/noimage.jpg';
      }

      return `
      <div class="swiper-slide block-voice__item">
        <a href="${item.href}" class="block-voice__link">
          <div class="headding">
            <p class="cate">${item.category.name}</p>
            <p class="ttl">${item.title}</p>
          </div>
          <div class="body">
            <dl>
              <dt>${company}</dt>
              <dd>${position}<br>${name}</dd>
            </dl>
            <figure class="thumb">
              <img src="${displayThumb}" alt="${item.title}" width="100%" loading="lazy">
            </figure>
          </div>
        </a>
      </div>`;
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          getArticle.render().then(() => {
            const voiceSlider = new Swiper('.block-voice__slide', {
              grabCursor: true,
              speed: 400,
              slidesPerView: 1.2,
              spaceBetween: 20,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: '.voice-next',
                prevEl: '.voice-prev',
              },
              breakpoints: {
                500: {
                  slidesPerView: 'auto',
                  spaceBetween: 38,
                }
              },
            });
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px 200px 0px'
    });

    const target = document.querySelector('.block-voice__slide-wrapper');
    if (target) {
      observer.observe(target);
    }
  }

  seminar () {
    const getArticle = new GET_ARTICLES('.block-seminar__article');
    
    const weekdayFullMap = {
      'SUN': 'SUNDAY', 'MON': 'MONDAY', 'TUE': 'TUESDAY', 'WED': 'WEDNESDAY', 
      'THU': 'THURSDAY', 'FRI': 'FRIDAY', 'SAT': 'SATURDAY'
    };

    getArticle.makeItem = (item, content) => {
      const [year, month, date, weekday] = item.desc.split('/');
      const fullWeekday = weekdayFullMap[weekday] || weekday;

      return `
      <div class="block-seminar__news">
        <h3 class="block-seminar__news-title">NEXT</h3>
        <p class="block-seminar__news-desc">
          <a href="${item.href}">${item.title}</a>
        </p>
      </div>
      <div class="block-seminar__calendar">
        <p class="block-seminar__calendar-year">${year}</p>
        <p class="block-seminar__calendar-date">${month}.${date}</p>
        <p class="block-seminar__calendar-dayweek">${fullWeekday}</p>
      </div>
      `;
    };
    getArticle.render();
  }

  news () {
    const getArticle = new GET_ARTICLES('.block-news__list');
    getArticle.makeItem = (item,content) => {
      return `
      <li class="block-news__item">
        <a href="${item.href}" class="block-news__link">
          <p class="info">
            <span class="date">${item.date}</span>
            <span class="cate">${item.category.name}</span>
          </p>
          <p class="ttl${(item.is_new)? ' is-new': ''}"><span>${item.title}</span></p>
        </a>
      </li>`};
    // getArticle.makeItem = (item) => console.log(item);
    getArticle.render();

    // カテゴリー
    const getCategories = this.fetchCategories('information');
    const categoryContainer = d.querySelectorAll('.block-news [data-plugin="getCategories"]');
    getCategories.then( cats => {
      cats = [ ...cats ];
      const makeHTML = cat => `<li class="block-news__cat-item"><a class="block-news__cat-link is-${cat.id}" href="${cat.href}">${cat.name}</a></li>`;
      categoryContainer.forEach( obj => {
        obj.innerHTML = '';
        cats.forEach( cat => obj.insertAdjacentHTML('beforeend', makeHTML(cat) ) );
      });
    });
  }
    
  fetchCategories (content) {
    return fetch(`/assets/api/getCategories/?content=${content}`)
      .then(r => r.json())
      .catch(e => { throw new Error(e)});
  }

  fetchArticles (opt){
    return fetch(`/assets/api/getArticles/?${ new URLSearchParams(opt)}`)
    .then(r => r.json())
    .catch(e => { throw new Error(e)});
  }

  bannerClose () {
    $('#fixedBannerClose').on('click',()=>{
      $('#fixedBanner').fadeOut();
    });
  }
}

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
}